export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const UPDATE_SOURCE = 'UPDATE_SOURCE';
export const RESET_ALL_REDUCERS = 'RESET_ALL_REDUCERS';

export const UPDATE_TWO_FA_SESSION = 'UPDATE_TWO_FA_SESSION';

export const UPDATE_USER_CONTACT_INFO = 'UPDATE_USER_CONTACT_INFO';
